// service
import ProjectService from '../../../project.service.js';
import { successMessage, errorMessage } from '@/utils/message.js';

export default {
  components: {
  },
  data() {
    return {
      statusType: [{code: 1, value: '通过'}, {code: 2, value: '拒绝'}],
      auditApplyInfo: {},
      attachmentInfo: [],
      legalImgArr: [],
      assignorImgArr: [],
      legalFront: [],
      legalBack: [],
      reasonText: '备注',
      form: {
        projectId: '',
        status: 1,
        reason: '',
        bidId: '',
        winningBidderId: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择资格意见', trigger: 'change' }
        ],
        reason: [
          { required: false, message: '请输入少于200字的备注信息', trigger: 'blur' }
        ]
      },
      userId: ''
    };
  },
  created() {
    const query = this.$route.query;
    this.form.projectId = query.projectId;
    this.form.status = query.status || '';
    this.form.bidId = query.bidId || '';
    this.form.winningBidderId = query.winningBidderId || '';
    this.userId = query.userId;
    this.formPath = query.formPath || '';
    this.getSignUserInfo();
  },
  watch: {
    'form.status'() {
      this.$nextTick(() => {
        if(this.$refs['form']) {
          this.$refs['form'].clearValidate();
        }
      });
      this.form.reason = '';
      if (this.form.status && this.form.status === 2) {
        this.reasonText = '拒绝原因';
        this.$set(this.rules.reason, 0, { required: true, message: '请输入少于200字的备注信息', trigger: 'blur' });
      } else {
        this.reasonText = '备注';
        this.$set(this.rules.reason, 0, { required: false, message: '请输入少于200字的备注信息', trigger: 'blur' });
      }
    }
  },
  methods: {
    // 审批
    approveSignQualification () {
      this.$confirm('确定要提交审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ProjectService.approveSignQualification(this.form).then(res => {
          if (res && res.code === '0') {
            successMessage('审核结果提交成功');
            this.$router.go(-1);
          } else if (res && res.reason){
            errorMessage(res.reason);
          } else {
            successMessage('审核结果提交失败');
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          } else {
            errorMessage('审核结果提交失败');
          }
        });
      }).catch();
    },
    // 查询详情
    getSignUserInfo () {
      ProjectService.getSignUserInfo(this.form.bidId, this.userId).then(res => {
        if (res && res.code === '0') {
          this.auditApplyInfo = res.data;
          if (this.auditApplyInfo.legalFront && this.auditApplyInfo.legalBack) {
            this.legalImgArr = [...this.auditApplyInfo.legalFront, ...this.auditApplyInfo.legalBack];
          }
          if (this.auditApplyInfo.assignorFront && this.auditApplyInfo.assignorBack) {
            this.assignorImgArr = [...this.auditApplyInfo.assignorFront, ...this.auditApplyInfo.assignorBack];
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.approveSignQualification();
        }
      });
    }
  }
};
